
export default {
  name: 'HolidayListSearchPanel',

  props: {
    projectUuid: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isSubmitForm: false,
      searchParams: {
        element: '',
        type: '',
        status: '',
      },
      types: [
        { value: 'permanent', label: 'Cykliczne' },
        { value: 'specific_day', label: 'W konkretnym dniu' },
        { value: 'regular', label: 'Okresowe' },
      ],
      status: [
        { value: 'current_holiday', label: 'Aktualne' },
        { value: 'past_holiday', label: 'Przeszłe' },
        { value: 'future_holiday', label: 'Nadchodzące' },
      ],
      elements: [
        { value: 'project', label: 'Projekt' },
        { value: 'agent', label: 'Agent' },
        { value: 'komunikat', label: 'Komunikat' },
        { value: 'menu_element', label: 'Menu główne' },
        { value: 'menu_b', label: 'Menu alternatywne' },
      ],
    };
  },

  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('changeFilterBy', newVal);
      },
      deep: true,
    },
  },

  methods: {
    async clearSearchParams() {
      this.searchParams.element = '';
      this.searchParams.type = '';
      this.searchParams.status = '';
    },
  },
};
